<template>
  <pt-coupon-review class="pt-coupon-review__withData" @pass="pass" ref="table"></pt-coupon-review>
</template>

<script>
import PtCouponReview from './index'
export default {
  name: 'pt-coupon-review__withData',
  components: {
    'pt-coupon-review': PtCouponReview
  },
  methods: {
    pass (val) {
      let data = {
        status: 'ACTIVATED',
        id: val.id
      }
      this.$store.dispatch('couponUpdateStatus', data).then(res => {
        this.$message.success('审核优惠劵成功')
        this.$refs.table.coupon_list()
      }).catch(err => {
        this.$message.error(err || '审核优惠劵失败')
      })
    }
  }
}
</script>
